@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.countries
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.MultiLingualTextDto

data class CountryDto(
    val id: KmmLong?,
    val code: String,
    val name: MultiLingualTextDto,
    val phoneCode: Array<String>,
)
